import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
import { mdiCancel, mdiTimerOffOutline } from "@mdi/js"
import {
  cancelContactOrderStepWithOrder,
  skipContactOrderStepWaitWithOrder,
} from "../../../../../../../../api/kehrblatt/contact-orders"
import type { ContactOrderStepActionContext } from "../_logic/contract"
import { resolveStepProgressionAction } from "../_shared/_logic/action-availability"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"
export default function buildActions(
  {
    step,
    stepId,
    caseId,
    contactOrderId,
    canSkipWait,
    canCancelStep,
    onApplyStepPatch,
    onContactOrderUpdated,
    onReloadContactOrders,
  }: ContactOrderStepActionContext & { canSkipWait: boolean; canCancelStep: boolean },
  state: { pending: boolean; resolved: boolean },
): TableRowAction[] {
  const action = resolveStepProgressionAction(step, stepId)
  const actionAllowed = Boolean(
    action && (action.kind === "skip_wait" ? canSkipWait : canCancelStep),
  )
  const iconPath = action?.icon === "timer_off" ? mdiTimerOffOutline : mdiCancel
  const runProgressionAction = async () => {
    if (!action || !stepId || state.pending || state.resolved) return

    state.pending = true
    try {
      const result =
        action.kind === "skip_wait"
          ? await skipContactOrderStepWaitWithOrder(caseId, contactOrderId, stepId)
          : await cancelContactOrderStepWithOrder(caseId, contactOrderId, stepId)
      state.resolved = true
      onContactOrderUpdated(result.order)
      onApplyStepPatch(stepId, result.step)
      await onReloadContactOrders()
      newNotification({
        class: "success",
        html: action.successMessage,
      })
    } catch (err) {
      console.error("contact_order_step_progression_failed", err)
      newNotification({
        class: "error",
        html: action.errorMessage,
      })
    } finally {
      state.pending = false
    }
  }
  const actions: TableRowAction[] = []

  if (actionAllowed && action && !state.resolved) {
    actions.push({
      id: "action-0",
      label: action.tooltip,
      onClick: () => runProgressionAction(),
      icon: iconPath,
      disabled: state.pending,
      tooltip: action.tooltip,
    })
  }

  return actions
}
